<style scoped>
.search-result {
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  padding: 20px;
  border-bottom: 2px solid var(--neutral3);
  width: 100%;
}

.search-result.mobile {
  padding: 0.5rem;
}

.search-result__lockup {
  flex-grow: 1;
}

.search-result__link {
  color: inherit;
  display: block;
  text-decoration: none;
}

.search-result.box .box__content {
  margin: 20px 0px 0px 0px;
}

.search-result__image {
  width: 100%;
}

.search-result__heading {
  margin-bottom: 10px;
}

.search-result__heading:hover {
  text-decoration: underline;
}

.search-result__recipients-heading {
  font-family: var(--sans-font);
  font-size: 14px;
  font-weight: 600;
}

.search-result__recipients {
  color: #787878;
  font-family: var(--sans-font);
  font-size: 14px;
}

.search-results__tick {
  color: #cacaca;
  width: 50px;
}

.search-result__progress-bar {
  margin-top: 3px;
}

.search-results__tags-grid {
  --grid-gutter: 5px;
}
a.profile-link {
  color: var(--color);
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-user-activity {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.a-hidden {
  text-decoration: none;
}
.title-update {
  display: block;
  margin-top: 10px;
}
.description-result {
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}
.button-tags.button {
  align-items: stretch !important;
  background: #ffffff !important;
  border: 1px solid !important;
  border-radius: 5px !important;
  border-color: var(--light-gray) !important;
  box-shadow: 0 0 0 -15em inset !important;
  box-sizing: border-box !important;
  color: var(--muted) !important;
  cursor: pointer !important;
  display: inline-flex !important;
  font-size: 15px !important;
  font-weight: normal !important;
  line-height: 1.3 !important;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center !important;
  text-decoration: none !important;
  transition: background-color 0.1s, border-color 0.1s, box-shadow 0.1s, color 0.1s, opacity 0.2s !important;
}
.button-tags.button span.button__content {
  padding: 0.2em 1em !important;
  font-size: 14px !important;
}
</style>

<template>
  <cp-box
    :style="{ width: widthData, marginBottom: '15px' }"
    v-bind:class="{ 'social-feed-post-wrapper': feed, 'search-result': true, mobile: $root.isMobile }"
  >
    <div class="search-result__lockup">
      <div v-if="explore && userAction && !forShare">
        <cp-grid spread stretch-content justify="spaceBetween">
          <cp-grid-item span="content" align="center">
            <a
              v-if="userAction.image && !(userAction.action == 'contributed' && userAction.public == 0) && userAction.action != 'Campaign update posted!'"
              :href="profile(userAction.slug)"
            >
              <img :src="userAction.image" class="image-user-activity" />
            </a>
            <span class="center">
              <div v-if="userAction.action == 'contributed' && userAction.public == 0" class="content-2 profile-link">
                <span> Anonymous </span>
              </div>
              <a v-else class="content-2 profile-link" :class="{ 'a-hidden': !userAction.slug }" :href="profile(userAction.slug)">
                <span v-if="userAction.first_name">
                  {{ userAction.first_name }}
                </span>
                <span v-if="userAction.last_name">
                  {{ userAction.last_name }}
                </span>
              </a>
              <span class="content-1"> {{ userAction.action }}</span>
            </span>
          </cp-grid-item>
          <cp-grid-item span="content" align="center">
            <cp-button-link v-if="userAction.slug" thin light-gray style="float: right" :href="'profile/' + userAction.slug">
              <span>View Profile</span>
            </cp-button-link>
          </cp-grid-item>
        </cp-grid>
      </div>

      <a class="search-result__link" :href="result.update && !result._highlightResult ? resultUpdateUrlAndSuffix : resultUrlAndSuffix">
        <div class="heading-2 search-result__heading">
          <span>{{ result.name }}</span>
          <span v-if="result.update?.name" class="title-update">{{ result.update?.name }}</span>
        </div>
        <CpShowImageInCard :image="!result.update || !result.update?.image_url ? result.image : result.update?.image_url" />

        <cp-box-content>
          <div class="search-results__result-header">
            <div>
              <div v-if="result.recipients.length === 1">
                <header class="search-result__recipients-heading">
                  <cp-result-highlight v-if="result._highlightResult" :hit="result" attribute="recipients.0.name" url></cp-result-highlight>
                  <a v-else class="search-result__link" :href="result.recipients[0].permalink">
                    <span>{{ result.recipients[0].name }}</span>
                  </a>
                </header>

                <div v-if="result.recipients[0].election_description" class="search-result__recipients">
                  <cp-result-highlight v-if="result._highlightResult" :hit="result" attribute="recipients.0.election_description"></cp-result-highlight>
                  <v-clamp :max-lines="5" v-else>{{ result.recipients[0].election_description }}</v-clamp>
                </div>
              </div>

              <div v-else>
                <header class="search-result__recipients">Campaign supporting {{ result.recipients.length }} recipients</header>

                <div class="search-result__recipients-heading">
                  <template v-for="(recipient, i) in result.recipients.slice(0, visibleRecipients)">
                    <cp-result-highlight v-if="result._highlightResult" :hit="result" :attribute="`recipients.${i}.name`" v-bind:key="i"></cp-result-highlight>
                    <span v-else v-bind:key="i">{{ result.recipients[i].name }}</span>
                    {{ result.recipients.length - 1 >= i ? ',' : null }}
                  </template>
                  <span
                    v-if="result.recipients.length > visibleRecipients"
                    :title="
                      result.recipients
                        .slice(visibleRecipients)
                        .map(r => r.name)
                        .join(', ')
                    "
                    >and {{ result.recipients.length - visibleRecipients }} more</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="search-results__result-description">
            <hr class="search-results__tick" />

            <div class="content-3">
              <v-clamp :max-lines="5" class="description-result">{{
                !result.update ? descriptionText(result.description) : descriptionText(result.update?.description)
              }}</v-clamp>
            </div>
          </div>
        </cp-box-content>
      </a>

      <cp-box-content class="search-result__tags-container">
        <cp-grid class="search-results__tags-grid">
          <cp-grid-item v-for="(tag, i) in result.tags" :key="tag">
            <cp-button-link class="button-tags" :href="tagHref(tag)">
              <cp-result-highlight v-if="result._highlightResult" :hit="result" :attribute="`tags.${i}`"></cp-result-highlight>
              <span v-else>{{ result.tags[i] }}</span>
            </cp-button-link>
          </cp-grid-item>
        </cp-grid>
      </cp-box-content>
    </div>

    <a class="search-result__link" :href="result.update && !result._highlightResult ? resultUpdateUrlAndSuffix : resultUrlAndSuffix">
      <cp-box-content>
        <cp-grid tight justify="spaceBetween">
          <cp-grid-item>
            <span :style="{ visibility: result.total_funds === 0 ? 'hidden' : null }">
              <strong>${{ result.total_funds.toLocaleString() }}</strong>
              Raised
            </span>
          </cp-grid-item>

          <cp-grid-item>
            <span :style="{ visibility: result.total_contributions === 0 ? 'hidden' : null }">
              <strong>{{ result.total_contributions.toLocaleString() }}</strong>
              {{ result.total_contributions === 1 ? 'Supporter' : 'Supporters' }}
            </span>
          </cp-grid-item>
        </cp-grid>

        <cp-progress-bar
          class="search-result__progress-bar"
          :value="result.goal_completed"
          max="100"
          small
          :style="{ visibility: result.show_fundraising_goal && result.total_contributions > 0 ? null : 'hidden' }"
        ></cp-progress-bar>
      </cp-box-content>
    </a>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount
        :type="type"
        :id="parseInt(result.objectID.match(/(\d+)/g)[0])"
        :likesCount="result.likes_count"
        :commentsCount="comments_count"
        :endorsesCount="endorses_count"
        :handleLikesModal="handleLikesModal"
        :handleEndorsesModal="handleEndorsesModal"
      />
    </div>

    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles
        :count-likes="result.likes_count"
        :id="parseInt(result.objectID.match(/(\d+)/g)[0])"
        :type="'crowdpac'"
        @close="handleLikesModal"
      ></cp-likes-profiles>
    </cp-dialog>

    <cp-dialog v-if="showEndorsesModal && !forShare">
      <cp-endorses-profiles
        :count-endorses="endorses_count"
        :id="parseInt(result.objectID.match(/(\d+)/g)[0])"
        :type="'crowdpac'"
        @close="handleEndorsesModal"
      ></cp-endorses-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button :type="'crowdpac'" :id="parseInt(result.objectID.match(/(\d+)/g)[0])" :liked="result.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button like">
        <endorse-action-button
          :id="parseInt(result.objectID.match(/(\d+)/g)[0])"
          :onSuccess="setCount"
          :endorsed="result.user_endorsed"
          :type="'crowdpac'"
          :modal="modal"
        />
      </div>
      <div v-if="result.button_donate" class="post-action-button like">
        <donate-action-button :id="parseInt(result.objectID.match(/(\d+)/g)[0])" :type="'crowdpac'" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="parseInt(result.objectID.match(/(\d+)/g)[0])" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :explore="explore"
          :allow-share-feed="true"
          share-category="Campaign"
          :type="'crowdpac'"
          :post="result"
          share-button-class="button--noborder"
          :url="resultUrlAndSuffixShared"
          title="Campaigns found via CrowdBlue - Social Network For Politics"
          :description="`Wanted to share this campaigns article I found on CrowdBlue, the Social Network for Politics.`"
          quote
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
          :results-url-suffix="resultsUrlSuffix"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post
      v-show="!forShare"
      :id="parseInt(result.objectID.match(/(\d+)/g)[0])"
      :type="type"
      :setCount="setCountComments"
    >
    </cp-comments-post>
    <cp-dialog v-if="showEndorseCommentModal">
      <cp-endorses-comment :result="result" @close="closeEndorseCommentModal" :setCount="setCount" :type="type"> </cp-endorses-comment>
    </cp-dialog>
  </cp-box>
</template>

<script>
import { SectionPostTypes } from '../constants';
import CpShowInteractionsCount from '../components/ShowInteractionsCount';
import CpShowImageInCard from '../components/ShowImageInCard';
import CpBox from '../box';
import CpBoxContent from '../box-content';
import CpButtonLink from '../button-link';
import CpDimensionSync from '../dimension-sync';
import CpGrid from '../grid';
import CpGridItem from '../grid-item';
import CpProgressBar from '../progress-bar';
import CpResultHighlight from './result-highlight';
import CpDialog from '../dialog';
import CpLikesProfiles from '../likes/likes-profiles';
import CpEndorsesProfiles from '../endorses/endorses-profiles';
import CpCommentsPost from '../comments/box-comments';
import VClamp from 'vue-clamp';

export default {
  components: {
    CpBox,
    CpBoxContent,
    CpButtonLink,
    CpDimensionSync,
    CpGrid,
    CpGridItem,
    CpProgressBar,
    CpResultHighlight,
    CpDialog,
    CpLikesProfiles,
    CpEndorsesProfiles,
    CpCommentsPost,
    CpIcon: require('../icon').default,
    CpSocialShareDialog: require('../dialogs/social-share').default,
    LikeActionButton: require('../social-feed/actions/like-action-button').default,
    CommentActionButton: require('../social-feed/actions/comment-action-button').default,
    EndorseActionButton: require('../explore-campaigns/actions/endorse-action-button').default,
    CpEndorsesComment: require('../endorses/endorses-comment').default,
    VClamp,
    DonateActionButton: require('../explore-campaigns/actions/donate-action-button').default,
    CpShowInteractionsCount,
    CpShowImageInCard,
  },

  props: {
    result: Object,
    sort: String,
    resultsUrlSuffix: [String, Boolean],
    explore: Boolean,
    feed: Boolean,
    forShare: Boolean, //Is shared in explore tab
    modal: Boolean,
  },

  data() {
    return {
      visibleRecipients: 3,
      showLikesModal: false,
      showEndorsesModal: false,
      showEndorseCommentModal: false,
      endorses_count: this.result.endorses_count,
      comments_count: this.result.comments_count,
      widthData: this.forShare || this.explore ? 'initial' : '100%',
      type: SectionPostTypes.CROWDPAC,
    };
  },

  watch: {
    result(newResult) {
      this.endorses_count = newResult.endorses_count;
      this.comments_count = newResult.comments_count;
    },
  },

  computed: {
    resultUpdateUrlAndSuffix() {
      if (this.resultsUrlSuffix) {
        return this.result.update?.permalink + this.resultsUrlSuffix;
      } else {
        return this.result.update?.permalink;
      }
    },
    resultUrlAndSuffix() {
      if (this.resultsUrlSuffix) {
        return this.result.permalink + this.resultsUrlSuffix;
      } else {
        return this.result.permalink;
      }
    },
    resultUrlAndSuffixShared() {
      return window.location.protocol + '//' + window.location.host + this.result.permalink;
    },
    authUser() {
      return this.$root.authUser;
    },
    userAction() {
      return this.result.last_activity;
    },
  },

  methods: {
    descriptionText(description) {
      //remove html tags so that vue clamp works properly
      return description.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ');
    },
    tagHref(tag) {
      return `?tags[]=${tag}${this.sort ? `&sort=${this.sort}` : ''}`;
    },
    profile(slug) {
      if (slug) {
        return '/profile/' + slug;
      }
      return null;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleEndorsesModal() {
      this.showEndorsesModal = !this.showEndorsesModal;
    },
    handleCountLikes(value) {
      value ? (this.result.likes_count = this.result.likes_count + 1) : (this.result.likes_count = this.result.likes_count - 1);
    },
    closeEndorseCommentModal() {
      this.showEndorseCommentModal = false;
    },
    setCount(type) {
      if (type == 'endorse') {
        this.showEndorseCommentModal = true;
        this.endorses_count++;
      } else {
        this.comments_count++;
      }
    },
    setCountComments(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
};
</script>
